var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediakit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5H8.20687L6.5 2.79312C6.40748 2.69986 6.29734 2.62592 6.17599 2.5756C6.05464 2.52528 5.9245 2.49958 5.79313 2.5H2.5C2.23478 2.5 1.98043 2.60535 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V12.5387C1.50033 12.7936 1.60171 13.0379 1.78191 13.2181C1.96211 13.3983 2.20641 13.4997 2.46125 13.5H13.5556C13.806 13.4997 14.046 13.4001 14.223 13.223C14.4001 13.046 14.4997 12.806 14.5 12.5556V5.5C14.5 5.23478 14.3946 4.98043 14.2071 4.79289C14.0196 4.60535 13.7652 4.5 13.5 4.5ZM2.5 3.5H5.79313L6.79313 4.5H2.5V3.5ZM13.5 12.5H2.5V5.5H13.5V12.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediakit);
export default __webpack_public_path__ + "static/media/mediakit.086984e837eea193a7369e57b596d153.svg";
export { ForwardRef as ReactComponent };